import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Box, Grid, MenuItem, Select, Typography, CircularProgress } from '@mui/material';
import { dashboardItemsSelector } from '../../redux/dashboard';
import { useSelector } from 'react-redux';

const Proposal = () => {
  const defaultChartData = useSelector(dashboardItemsSelector);
  const chartData = defaultChartData?.chartData?.proposalData?.data;
  const isLoading = defaultChartData?.chartData?.proposalData?.isLoading;

  const [range, setRange] = useState('week');
  const [viewType, setViewType] = useState('week');

  const handleChange = (event) => {
    setViewType(event.target.value);
  };

  const data = chartData?.[viewType]?.map((item) => {
    return {
      name: item?.name,
      NPlan: item?.normal,
      IV: item?.subscription,
    };
  });

  return (
    <Box title="Order Growth" style={{ flexGrow: 1, width: '100%' }}>
      <Typography variant="h3" className="mediumFont" style={{ marginTop: 20 }}>
        {'Proposal Data'}
      </Typography>
      <Grid
        container
        spacing={2}
        style={{
          marginLeft: 30,
          marginRight: 30,
          marginTop: 10,
          alignItems: 'center',
          height: 90,
        }}
      >
        <Grid size={{ xs: 6, md: 8 }} style={{ flexGrow: 1 }}>
          <Select
            value={viewType}
            onChange={handleChange}
            style={{ width: 120, height: 30 }}
          >
            <MenuItem value="week">Daily</MenuItem>
            <MenuItem value="month">Weekly</MenuItem>
            <MenuItem value="year">Monthly</MenuItem>
          </Select>
        </Grid>
      </Grid>

      <ResponsiveContainer width="100%" height={300}>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress size={30} />
          </div>
        ) : (
          <BarChart margin={{ right: 20 }} data={data}>
            <XAxis
              dataKey="name"
              style={{ fontSize: viewType === 'year' ? '8px' : '10px' }}
              minTickGap={2}
              interval={0}
              padding={{ right: 20 }}
            />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="NPlan" fill="#1976d2" />
            <Bar dataKey="IV" fill="#2e7d32" />
          </BarChart>
        )}
      </ResponsiveContainer>
    </Box>
  );
};

export default Proposal;
